import { defineStore } from 'pinia';
import { fetchGeOwnCustomLevel, fetchGetLevelConfig } from '@/services';

interface State {
  /** 会员等级 */
  ownCustomlevel: AnyObject | null
  /** 会员等级配置 */
  levelsConfig:  AnyObject | null
  /** 当前选择的会员等级下标 */
  swiperCurrentIndex: number;
}

export const useMembershipLevelStore = defineStore('membershipLevel', {
  state: (): State => ({
    ownCustomlevel: null,
    levelsConfig: null,
    swiperCurrentIndex: 0,
  }),

  getters: {
    /** 是否有等级会员 */
    isMemberLevel(state) {
      return !!state.ownCustomlevel;
    },
    /** 是否有等级会员配置 */
    displayMembershipLevelFlag(state) {
      return !!state.levelsConfig && state.levelsConfig.enabled;
    },
    /** 会员等级配置项 */
    levelConfigs(state) {
      return state.levelsConfig && state.levelsConfig?.levelsConfig?.levels || [];
    },
    /** 当前用户的会员等级 */
    currrentMemberLevel() {
      const index = this.ownCustomlevel?.level as number;
      const levels = this.levelConfigs as any[];
      if (typeof index === 'number' && Array.isArray(levels)) {
        return levels[index];
      }
      return null;
    }
  },

  actions: {
    async getOwnCustomLevel(refresh?: boolean) {
      if (!this.ownCustomlevel || refresh) {
        const data = await fetchGeOwnCustomLevel();
        if (data) {
          this.ownCustomlevel = data;
          this.swiperCurrentIndex = data?.level as number;
        };
      }
      console.log('ownCustomlevel-----', this.ownCustomlevel);
      
      return this.ownCustomlevel;
    },
    async getLevelConfigList() {
      const data = await fetchGetLevelConfig();
      if (data) this.levelsConfig = data;
      console.log('levelsConfig-----', this.levelsConfig);
      return this.levelsConfig;
    },

    /**
     * 从合并查询结果批量设置会员等级数据
     * 用于场景一优化：减少串行请求
     */
    setFromInit(data: {
      getLevelConfig?: AnyObject | null;
      getOwnCustomlevel?: AnyObject | null;
    }) {
      // 设置会员等级配置
      if (data.getLevelConfig) {
        this.levelsConfig = data.getLevelConfig;
        console.log('levelsConfig (from init)-----', this.levelsConfig);
      }

      // 设置用户自己的会员等级
      if (data.getOwnCustomlevel) {
        this.ownCustomlevel = data.getOwnCustomlevel;
        this.swiperCurrentIndex = data.getOwnCustomlevel?.level as number ?? 0;
        console.log('ownCustomlevel (from init)-----', this.ownCustomlevel);
      }
    },
  },
});